import { UIMessageStatus } from "../../enums";

export function isLoading(props: UIMessageStatus) {
    return props === UIMessageStatus.Waiting ? true : undefined;
}

export function isRejected(props: UIMessageStatus) {
    return props === UIMessageStatus.Error ? true : undefined;
}